<ng-container *transloco="let t">
    <mat-card class="altair-card performance-of-agents-card mb-25 border-radius bg-white border-none d-block"
        [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    {{name}}
                </h5>
            </mat-card-title>
             <mat-card-subtitle>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="performance-of-agents-table">
                <div class="table-responsive"  #TABLE>
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="supervisorName" matSortDirection="asc" matSortDisableClear>

                        <!-- supervisorName Column -->
                        <ng-container matColumnDef="supervisorName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('supervisor-name')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.supervisorName}}
                            </td>
                        </ng-container>

                        <!-- assessmentName Column -->
                        <ng-container matColumnDef="assessmentName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('assessment-name')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.assessmentName}}
                            </td>
                        </ng-container>

                        <!-- severityLevel Column -->
                        <ng-container matColumnDef="severityLevel">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('severity-level')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <p style="background-color:{{element.color}};color: black; text-align:center">{{element.severityLevel}}</p>
                            </td>
                        </ng-container>

                        <!-- numberVulnerabilities Column -->
                        <ng-container matColumnDef="numberVulnerabilities">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('total-vulnerabilities')}}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.numberVulnerabilities}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
                <button mat-raised-button color="altair" (click)="exportTOExcel()">{{t('export-as-excel')}}</button>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
